import * as kea from "kea-react";
import * as React from "react";
import * as models from "app/models/requireme";
import { fa } from "typed-font-awesome";

interface Props {
    /**Cantidad de facturas seleccionadas */
    cant: number;
    /**Botón para crear REPs para varias facturas */
    onPagar: () => void;
    onTimbrar: () => void;
}

/**Botones del toolbar de facturación */
export class FacturasToolbarView extends React.PureComponent<Props> {
    render() {
        return (
            <>
             
                <kea.Button onClick={this.props.onPagar} iconClass={fa("money", "fw")} style="success"  >
                    Pagar
                </kea.Button>
                <kea.Button onClick={this.props.onTimbrar} iconClass={fa("bell", "fw")} style="warning" >
                    Timbrar
                </kea.Button>

                   {
                    this.props.cant ?
                    <span className="badge">{this.props.cant}</span> : null
                }
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/facturas/view.tsx